import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useI18n, SUPPORTED } from "@/i18n";

export default function LanguageSwitcher({ onSwitch }) {
  const { lang, t } = useI18n();
  const location = useLocation();
  const navigate = useNavigate();

  const switchTo = (target) => {
    if (target === lang) return;
    const parts = location.pathname.split("/").filter(Boolean);
    if (SUPPORTED.includes(parts[0])) parts[0] = target;
    else parts.unshift(target);
    navigate("/" + parts.join("/") + location.hash, { replace: false });
    if (onSwitch) onSwitch();
  };

  const btnBase = "px-2 py-1 text-xs uppercase tracking-[0.18em] font-mono-brand border";
  return (
    <div
      className="inline-flex"
      role="group"
      aria-label={t("nav.languageLabel")}
      data-testid="language-switcher"
    >
      <button
        type="button"
        onClick={() => switchTo("ar")}
        className={`${btnBase} ${lang === "ar" ? "bg-white text-[var(--brand-navy)] border-white" : "text-white/80 border-white/40 hover:bg-white/10"}`}
        aria-pressed={lang === "ar"}
        data-testid="lang-btn-ar"
      >
        ES
      </button>
      <button
        type="button"
        onClick={() => switchTo("en")}
        className={`${btnBase} -ml-px ${lang === "en" ? "bg-white text-[var(--brand-navy)] border-white" : "text-white/80 border-white/40 hover:bg-white/10"}`}
        aria-pressed={lang === "en"}
        data-testid="lang-btn-en"
      >
        EN
      </button>
    </div>
  );
}
